/*
 * (c) Meta Platforms, Inc. and its affiliates.
 */

import React from "react";
import * as d3 from "d3";
import MainNavbar from "../navbars/MainNavBar";
import Footer from "../footers/MainFooter";
import {
	FeatureCollection,
	DataPoint,
	SearchBoxOptions,
} from "../../utils/DemoTypes";
import SearchBoxCard from "../cards/SearchBoxCard";
import { MapboxGeoJSONFeature } from "react-map-gl";
import ImagesCard from "../cards/ImagesCard";
import InfoEventsActionsCard from "../cards/InfoEventsActionsCard";
import MapViz from "../maps/MapViz";
import MetadataModal from "../modals/MetadataModal";
//import MapVizClusters from "../maps/MapVizClusters"; // Mapbox

const ExplorerPage = () => {
	const [isFetching, setIsFetching] = React.useState<boolean>(false);
	const [unfilteredData, setUnfilteredData] = React.useState<any[]>([]);
	const [filteredData, setFilteredData] = React.useState<DataPoint[]>([]);
	const [options, setOptions] = React.useState<SearchBoxOptions[]>([]);
	const [featureData, setFeatureData] = React.useState<FeatureCollection>();
	const [showImgGrid, setShowImgGrid] = React.useState<boolean>(false);
	const [modalOpen, setModalOpen] = React.useState<boolean>(false);
	const [modalData, setModalData] = React.useState<any>({});
	const [gridData, setGridData] = React.useState<
		GeoJSON.Feature<GeoJSON.Geometry>[]
	>([]);

	/**
	 * Loads static data on page mount.
	 */
	React.useEffect(() => {
		setIsFetching(true);
		d3.csv("annotations-3.csv").then((data) => {
			setUnfilteredData(data);
			setFilteredData(data as any);
			setOptions(
				data.columns.map((i) => ({ columnField: i, type: "selection" }))
			);
			setIsFetching(false);
		});
	}, []);

	/**
	 * Format filtered data as features to be
	 * read as clusters by map-gl. Updates when filtered
	 * data changes.
	 */
	React.useEffect(() => {
		const POSITION_OFFSET = 0.35; // Spread points.
		const formatted_data: MapboxGeoJSONFeature[] | any = filteredData.map(
			(i: DataPoint) => {
				let longitude =
					parseFloat(i.lng as string) + Math.random() - POSITION_OFFSET;
				let latitude =
					parseFloat(i.lat as string) + Math.random() - POSITION_OFFSET;
				return {
					type: "Feature",
					geometry: {
						type: "Point",
						coordinates: [longitude, latitude],
					},
					properties: { ...i, lat: latitude, lng: longitude },
				};
			}
		);

		setFeatureData({ type: "FeatureCollection", features: formatted_data });
	}, [filteredData]);

	if (isFetching) return <div>_Loading...</div>;

	return (
		<div className="w-screen h-screen">
			<MainNavbar position="fixed" variant="light" />
			<SearchBoxCard
				unfilteredData={unfilteredData}
				options={options}
				setFilteredData={setFilteredData}
			/>
			<InfoEventsActionsCard />

			<MapViz
				data={featureData!}
				setGridData={setGridData}
				setShowImgGrid={setShowImgGrid}
			/>
			{showImgGrid && (
				<ImagesCard
					data={gridData}
					setShowImgGrid={setShowImgGrid}
					setModalOpen={setModalOpen}
					setModalData={setModalData}
				/>
			)}
			{showImgGrid && modalOpen && (
				<MetadataModal
					modalOpen={modalOpen}
					setOpenModal={setModalOpen}
					data={modalData}
				/>
			)}
			<Footer position="fixed" variant="light" />
		</div>
	);
};

export default ExplorerPage;
